module.exports = __webpack_public_path__ + "static/media/qrcode.75c9806d.svg";